<template>
    <div v-if="element?.style?.customCss" v-html="'<style>' + element.style.customCss + '</style>'"></div>
    <div class="element-wrapper" :class="element.id + '-wrapper'" v-if="element?.props" @dblclick.stop="onClick">
        <div :id="`tab-${element.id}`" class="tab-element">
            <!-- TAB BUTTONS -->
            <ul class="nav twpb-nav-tabs" :class="element.props.themeStyle" :id="`tablist-${element.id}`" role="tablist">
                <li class="twpb-nav-item" role="presentation" v-for="item in element.props.items" :key="`tab-button-${element.id}-${item.id}`">
                    <button
                        :id="`tab-${element.id}-btn-${item.id}`"
                        class="twpb-nav-link tab-element-button"
                        :class="{ active: item.active }"
                        type="button"
                        role="tab"
                        :aria-controls="`tab-${element.id}-pane-${item.id}`"
                        :aria-selected="item.active ? 'true' : 'false'"
                        :style="element.props.themeStyle ? {} : item.active ? labelActiveStyle : labelInactiveStyle"
                        @click="changeTabActive(item)"
                    >
                        {{ item.title }}
                    </button>
                </li>
            </ul>

            <!-- TAB CONTENT -->
            <div :id="`tab-content-${element.id}`" class="twpb-tab-content" :class="element.props.themeStyle">
                <div
                    v-for="item in element.props.items"
                    :key="`tab-pane-${element.id}-${item.id}`"
                    class="twpb-tab-pane tab-element-content"
                    role="tabpanel"
                    :id="`tab-${element.id}-pane-${item.id}`"
                    :aria-labelledby="`tab-${element.id}-btn-${item.id}`"
                    :style="styleObject"
                    tabindex="0"
                    v-show="item.active"
                >
                    <div v-html="item.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Tab",
    props: {
        element: {
            required: false,
            type: Object,
        },
    },
    methods: {
        onClick() {
            this.$emit("onClick", this.element);
        },
        changeTabActive(item) {
            this.element.props.items.forEach((i) => {
                i.active = i.id === item.id;
            });
            this.$emit("tabElement", this.element);
        },
    },
    computed: {
        styleObject() {
            return {
                backgroundColor: this.element?.style?.backgroundColor || "transparent",
                padding: this.element?.style?.padding || "0px",
            };
        },
        labelInactiveStyle() {
            return {
                color: this.element?.style?.inactiveLabelColor || "inherit",
                backgroundColor: this.element?.style?.inactiveLabelBackgroundColor || "transparent",
                padding: this.element?.style?.labelPadding || "0px",
                fontSize: this.element?.style?.labelFontSize && this.element.style.labelFontSize !== "0px" ? this.element.style.labelFontSize : "inherit",
            };
        },
        labelActiveStyle() {
            return {
                color: this.element?.style?.activeLabelColor || "inherit",
                backgroundColor: this.element?.style?.activeLabelBackgroundColor || this.element?.style?.backgroundColor || "white",
                padding: this.element?.style?.labelPadding || "0px",
                fontSize: this.element?.style?.labelFontSize && this.element.style.labelFontSize !== "0px" ? this.element.style.labelFontSize : "inherit",
            };
        },
    },
    emits: ["onClick", "tabElement"],
};
</script>
